// export Context from './context';
export { default as Scope } from './scope';
export { default as ContextProvider } from './contextProvider';
export type { IController, IControllerAction, IMethodsProps } from './interface';
